export enum ValueType {
    DEPOSIT_AMOUNT= "DEPOSIT_AMOUNT",
    LOAN_AMOUNT = "LOAN_AMOUNT",
    LTV_PERCENTAGE = "LTV_PERCENTAGE"
}
export const defaultDepositAmount = "125000";
export const defaultLoanAmount = "125000";
export const defaultLTVPercentage = "60";

export const DEFAULT_PROPERTY_VALUE = "250000";
